
const WEB_CONTEXT = '/';
// const baseURL = 'http://47.106.226.170:18080';
// const baseURL = 'http://47.106.240.52:18080';
// const baseURL = 'http://47.95.99.207';
const baseURL = '';

const constConfig = {
  webContext: WEB_CONTEXT,
  axiosBaseURL: baseURL,
  indexPage: WEB_CONTEXT,
  igonreErrorURL: ['/api/logout.do', '/api/common/operateToken.do'],
  axiosWithCredentials: true,
  axiosTimeout: 5000,
  tokenURL: '/api/common/operateToken.do',
  tokenName: 'lbgj-user-token',
  tokenHeaderName: 'JWT_TOKEN',
  persistName: 'lbgj-vuex-key',
};

export default constConfig;



// WEBPACK FOOTER //
// ./src/util/constConfig.js